import React from 'react'

const Services = () => {
  return (
    <>
    <div>
    <span>
    <b>Lung cancer </b>is a major public health concern and the most common cause of cancer-related deaths worldwide. Early detection and diagnosis are essential for effective treatment, but they can be challenging due to the complexity of lung cancer and the limitations of existing screening methods. Machine learning (ML) models can help in the early detection and diagnosis of lung cancer, by analyzing patient data and providing accurate and reliable predictions. 
    </span>
    <br />
    <br />
    <p> <b>Lung cancer classification ML model </b> is a deep learning model that has been trained on a large dataset of lung cancer images and patient data. The model can classify lung nodules as malignant or benign, with a high degree of accuracy. The model uses various features of the lung nodules, such as size, shape, and texture, to make its predictions.</p>
    
    <br />
    <b>The web application can provide several services based on the Lung cancer classification ML model. These services can include:</b>
    <br />
    <br />
    <p>1. <b>Early detection of lung cancer:</b> The web application can be used to screen patients for early detection of lung cancer. The Lung cancer classification ML model can analyze lung nodule images and patient data to provide accurate predictions.</p>
    <p>2. <b>Diagnosis of lung cancer:</b> The web application can be used to help the doctors to diagnose lung cancer in patients. The Lung cancer classification ML model can analyze lung nodule images and patient data to provide accurate diagnoses.</p>
    {/* <p>3. <b>Monitoring of lung cancer:</b>The web application can be used to monitor patients with lung cancer. The Lung cancer classification ML model can analyze lung nodule images and patient data to track the progress of the disease and provide accurate predictions on the effectiveness of treatment.</p> */}
    <br />
    <p>Overall, Our Lung cancer classification ML model and web application can provide valuable services for early detection, diagnosis, and monitoring of lung cancer,</p>
    </div>
    </>
  )
}

export default Services